/* Kingsley — premium page transitions.
   Thin top progress bar + subtle main content rise/fade on arrival.
   Outgoing: progress bar + soft dim; content drifts up a hair.
   Incoming: main rises from blur + fade. No whiteout. */
(function () {
  var root = document.documentElement;

  var bar = document.createElement('div');
  bar.className = 'qs-nav-bar';
  root.appendChild(bar);

  var veil = document.createElement('div');
  veil.className = 'qs-page-fade';
  root.appendChild(veil);

  root.classList.add('qs-enter');
  var enterTimer = setTimeout(function () {
    root.classList.remove('qs-enter');
  }, 640);

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      clearTimeout(leaveWatchdog);
      root.classList.remove('qs-leave');
      bar.classList.remove('is-active', 'is-done');
      veil.classList.remove('is-out');
      root.classList.remove('qs-enter');
      void root.offsetWidth;
      root.classList.add('qs-enter');
      clearTimeout(enterTimer);
      enterTimer = setTimeout(function () {
        root.classList.remove('qs-enter');
      }, 640);
    }
  });

  window.addEventListener('pagehide', function () {
    bar.classList.add('is-done');
  });

  function isInternalLink(a) {
    if (!a || !a.href) return false;
    if (a.target && a.target !== '' && a.target !== '_self') return false;
    if (a.hasAttribute('download')) return false;
    if (a.dataset.noFade === 'true') return false;
    var url;
    try { url = new URL(a.href, location.href); } catch (_) { return false; }
    if (url.origin !== location.origin) return false;
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
    if (url.pathname === location.pathname && url.search === location.search && url.hash) return false;
    return true;
  }

  var leaveWatchdog;

  function startLeaving() {
    root.classList.add('qs-leave');
    veil.classList.add('is-out');
    bar.classList.remove('is-done');
    void bar.offsetWidth;
    bar.classList.add('is-active');

    // Safety net: if no navigation actually happens (e.g. a handler cancels it
    // after we've started), clear the dim veil so the page never stays stuck /
    // unusable. A real navigation unloads the page long before this fires.
    clearTimeout(leaveWatchdog);
    leaveWatchdog = setTimeout(stopLeaving, 6000);
  }

  function stopLeaving() {
    clearTimeout(leaveWatchdog);
    root.classList.remove('qs-leave');
    veil.classList.remove('is-out');
    bar.classList.remove('is-active');
    bar.classList.add('is-done');
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    if (e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (!(e.target instanceof Element)) return;

    // In-card controls (slideshow chevrons, quick-add, swatches, qty, etc.) are
    // <button>/<input>-style elements that often sit INSIDE the card's <a href>.
    // A click on one of them is an action, never a page navigation — never fade.
    if (e.target.closest('button, [role="button"], input, select, textarea, label, summary')) return;

    // Never fade for clicks inside an overlay (cart drawer, search / quick-add
    // dialog, nav drawer, modals). In-overlay clicks aren't page navigations
    // (checkout posts a form), and closing the overlay afterwards could otherwise
    // leave the dim veil stuck — the "dimmed & unusable after closing the cart"
    // bug. Backdrop clicks target the <dialog> itself, so this catches those too.
    if (e.target.closest('dialog, cart-drawer-component, .cart-drawer, header-drawer, drawer-component, [data-overlay]')) return;

    var a = e.target.closest('a');
    if (!isInternalLink(a)) return;

    // Second layer for clicks that land on the link itself but get cancelled by
    // a handler in the bubble phase (e.g. the slideshow's drag-to-suppress-click).
    // This listener is capture-phase, so defer to a microtask and re-read
    // defaultPrevented once dispatch has fully completed — only fade if the click
    // really will navigate. The microtask still runs before the browser's
    // navigation task, so the bar/veil appear in time for genuine link clicks.
    Promise.resolve().then(function () {
      if (e.defaultPrevented) return;
      // Do NOT preventDefault — let browser navigate; bar animates during network.
      startLeaving();
    });
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.dataset.noFade === 'true') return;
    if ((f.method || 'get').toLowerCase() !== 'get') return;
    startLeaving();
  }, true);

  window.addEventListener('beforeunload', function () {
    startLeaving();
  });
})();
